export default __webpack_public_path__ + "70bf32710f329aadb9f4d3f22acce42e.png";